import { render, staticRenderFns } from "./BmUsuarios.vue?vue&type=template&id=904dbf70&"
import script from "./BmUsuarios.vue?vue&type=script&lang=js&"
export * from "./BmUsuarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports